// @flow
import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

type DefaultData = *;

type Props = {
  defaultData: ?DefaultData,
  onUpdate: DefaultData => void
};

const useStyles = makeStyles((theme) => ({
  paperRoot: {
    padding: theme.spacing(4)
  },
  formControl: {
    minWidth: 120,
    width: '100%'
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}))

const Strengths = ({ defaultData, onUpdate }: Props): React$Node => {
  const classes = useStyles()
  const [data, setData] = useState(defaultData || {
    'Building effective teams': false,
    'Mentoring and developing talent': false,
    'Giving and receiving feedback': false,
    'Managing digital transformation': false,
    'Launching new products': false,
    'Globalization or entering new markets': false,
    'Making "build or buy" decisions': false,
    'Managing turnaround situations': false,
    'Managing through M&A': false,
    'Cost containment': false,
    'The latest digital technology trends': false,
    'Influencing stakeholder buy-in': false
  })
  const [error, setError] = useState(undefined)
  const limitReached = Object.values(data).filter(d => d).length >= 3;

  const handleChange = e => {
    if (limitReached && e.target.checked) return;

    setError(undefined)
    setData(state => ({
      ...state,
      [e.target.name]: e.target.checked
    }))
  }

  // Pass updates to data back up to the parent component
  useEffect(() => {
    onUpdate(data)
  }, [data])

  return (
    <div>
      <Container>
        <form>
          <Grid container spacing={3} justify='center'>
            <Grid item xs={10}>
              <Typography variant="h3">Your Strengths</Typography>
              <Typography>Select up to 3 topics where you can provide unique insight</Typography>
            </Grid>
            <Grid item xs={10}>
              <FormControl component="fieldset" className={classes.formControl}>
                <FormGroup>
                  {Object.keys(data).sort().map(label => (
                    <FormControlLabel
                      key={label}
                      control={<Checkbox checked={data[label]} onChange={handleChange} name={label} />}
                      label={label}
                    />
                  ))}
                </FormGroup>
              </FormControl>
            </Grid>
          </Grid>
        </form>
      </Container>
    </div>
  )
}

export default Strengths
